/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { DataMetaInformationForMyDatasets } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * UserUploadsControllerApi - axios parameter creator
 */
export const UserUploadsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve an augmented dataset meta information uploaded by a specific user for the \"My Datasets\" page.
         * @summary Retrieve an augmented dataset meta information uploaded by a specific user.
         * @param {string} userId The Dataland user ID of the user who uploaded the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUploadsDataMetaInformation: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserUploadsDataMetaInformation', 'userId', userId)
            const localVarPath = `/users/{userId}/uploads`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserUploadsControllerApi - functional programming interface
 */
export const UserUploadsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserUploadsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve an augmented dataset meta information uploaded by a specific user for the \"My Datasets\" page.
         * @summary Retrieve an augmented dataset meta information uploaded by a specific user.
         * @param {string} userId The Dataland user ID of the user who uploaded the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserUploadsDataMetaInformation(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataMetaInformationForMyDatasets>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserUploadsDataMetaInformation(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserUploadsControllerApi.getUserUploadsDataMetaInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserUploadsControllerApi - factory interface
 */
export const UserUploadsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserUploadsControllerApiFp(configuration)
    return {
        /**
         * Retrieve an augmented dataset meta information uploaded by a specific user for the \"My Datasets\" page.
         * @summary Retrieve an augmented dataset meta information uploaded by a specific user.
         * @param {string} userId The Dataland user ID of the user who uploaded the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUploadsDataMetaInformation(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataMetaInformationForMyDatasets>> {
            return localVarFp.getUserUploadsDataMetaInformation(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserUploadsControllerApi - interface
 */
export interface UserUploadsControllerApiInterface {
    /**
     * Retrieve an augmented dataset meta information uploaded by a specific user for the \"My Datasets\" page.
     * @summary Retrieve an augmented dataset meta information uploaded by a specific user.
     * @param {string} userId The Dataland user ID of the user who uploaded the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserUploadsDataMetaInformation(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataMetaInformationForMyDatasets>>;

}

/**
 * UserUploadsControllerApi - object-oriented interface
 */
export class UserUploadsControllerApi extends BaseAPI implements UserUploadsControllerApiInterface {
    /**
     * Retrieve an augmented dataset meta information uploaded by a specific user for the \"My Datasets\" page.
     * @summary Retrieve an augmented dataset meta information uploaded by a specific user.
     * @param {string} userId The Dataland user ID of the user who uploaded the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserUploadsDataMetaInformation(userId: string, options?: RawAxiosRequestConfig) {
        return UserUploadsControllerApiFp(this.configuration).getUserUploadsDataMetaInformation(userId, options).then((request) => request(this.axios, this.basePath));
    }
}

